export const MAP_SIZE_LIMIT = [872, 600]
export const MAP_ICON_SIZE = 40 * 4

export const LIST_UP_COLOR = '#92BC62'

const SVG_COLORS = {
  up: {
    default: {
      bgcolor: '#CEE3B3',
      bordercolor: 'white',
      svgColorFilter: 'invert(29%) sepia(54%) saturate(448%) hue-rotate(49deg) brightness(101%) contrast(91%)'
    },
    hover: {
      bgcolor: '#E6F0D7',
      bordercolor: '#AED086'
    },
    active: {
      bordercolor: '#587F31',
      bgcolor: '#92BC62',
      svgColorFilter: 'invert(100%) sepia(100%) saturate(0%) hue-rotate(288deg) brightness(102%) contrast(102%)'
    }
  },
  installed: {
    default: {
      bgcolor: '#CEE3B3',
      bordercolor: 'white',
      svgColorFilter: 'invert(29%) sepia(54%) saturate(448%) hue-rotate(49deg) brightness(101%) contrast(91%)'
    },
    hover: {
      bgcolor: '#E6F0D7',
      bordercolor: '#AED086'
    },
    active: {
      bordercolor: '#587F31',
      bgcolor: '#92BC62',
      svgColorFilter: 'invert(100%) sepia(100%) saturate(0%) hue-rotate(288deg) brightness(102%) contrast(102%)'
    }
  },
  down: {
    default: {
      bgcolor: '#FECACA',
      bordercolor: 'white',
      svgColorFilter: 'invert(23%) sepia(84%) saturate(2581%) hue-rotate(348deg) brightness(90%) contrast(90%)'
    },
    hover: {
      bgcolor: '#FEE2E2',
      bordercolor: '#FCA5A5'
    },
    active: {
      bordercolor: '#DC2626',
      bgcolor: '#F87171',
      svgColorFilter: 'invert(100%) sepia(100%) saturate(0%) hue-rotate(288deg) brightness(102%) contrast(102%)'
    }
  },
  radio_enabled: {
    default: {
      bordercolor: '#FFFFFF',
      bgcolor: '#2570eb',
      svgColorFilter: 'brightness(0) invert(1)'
    },
    hover: {
      bgcolor: '#BED4F9',
      bordercolor: '#9DC1FB'
    },
    active: {
      bgcolor: '#DBE8FE',
      bordercolor: '#9DC1FB',
      svgColorFilter: 'invert(32%) sepia(93%) saturate(1564%) hue-rotate(206deg) brightness(97%) contrast(93%)'
    }
  },
  planned: {
    default: {
      bgcolor: '#C3DDF4',
      bordercolor: 'white',
      svgColorFilter: 'invert(33%) sepia(56%) saturate(1367%) hue-rotate(178deg) brightness(92%) contrast(87%)'
    },
    hover: {
      bgcolor: '#E4EEFA',
      bordercolor: '#8EC1EB'
    },
    active: {
      bordercolor: '#1D6BAF',
      bgcolor: '#52A1DE',
      svgColorFilter: 'invert(100%) sepia(100%) saturate(0%) hue-rotate(288deg) brightness(102%) contrast(102%)'
    }
  },
  muted: {
    default: {
      bgcolor: '#C3DDF4',
      bordercolor: 'white',
      svgColorFilter: 'invert(33%) sepia(56%) saturate(1367%) hue-rotate(178deg) brightness(92%) contrast(87%)'
    },
    hover: {
      bgcolor: '#E4EEFA',
      bordercolor: '#8EC1EB'
    },
    active: {
      bordercolor: '#1D6BAF',
      bgcolor: '#52A1DE',
      svgColorFilter: 'invert(100%) sepia(100%) saturate(0%) hue-rotate(288deg) brightness(102%) contrast(102%)'
    }
  },
  works: {
    default: {
      bgcolor: '#E6D3B2',
      bordercolor: 'white',
      svgColorFilter: 'invert(39%) sepia(99%) saturate(281%) hue-rotate(360deg) brightness(93%) contrast(92%)'
    },
    hover: {
      bgcolor: '#F0E4D1',
      bordercolor: '#D2B074'
    },
    active: {
      bordercolor: '#9A7432',
      bgcolor: '#C89E55',
      svgColorFilter: 'invert(100%) sepia(100%) saturate(0%) hue-rotate(288deg) brightness(102%) contrast(102%)'
    }
  },
  works_up: {
    default: {
      bgcolor: '#E6D3B2',
      bordercolor: 'white',
      svgColorFilter: 'invert(39%) sepia(99%) saturate(281%) hue-rotate(360deg) brightness(93%) contrast(92%)'
    },
    hover: {
      bgcolor: '#F0E4D1',
      bordercolor: '#D2B074'
    },
    active: {
      bordercolor: '#9A7432',
      bgcolor: '#C89E55',
      svgColorFilter: 'invert(100%) sepia(100%) saturate(0%) hue-rotate(288deg) brightness(102%) contrast(102%)'
    }
  },
  works_down: {
    default: {
      bgcolor: '#E6D3B2',
      bordercolor: 'white',
      svgColorFilter: 'invert(39%) sepia(99%) saturate(281%) hue-rotate(360deg) brightness(93%) contrast(92%)'
    },
    hover: {
      bgcolor: '#F0E4D1',
      bordercolor: '#D2B074'
    },
    active: {
      bordercolor: '#9A7432',
      bgcolor: '#C89E55',
      svgColorFilter: 'invert(100%) sepia(100%) saturate(0%) hue-rotate(288deg) brightness(102%) contrast(102%)'
    }
  },
  hibernation: {
    default: {
      bgcolor: '#D1D1D1',
      bordercolor: 'white',
      svgColorFilter: 'invert(39%) sepia(3%) saturate(0%) hue-rotate(137deg) brightness(88%) contrast(85%);'
    },
    hover: {
      bgcolor: '#E7E7E7',
      bordercolor: '#B0B0B0'
    },
    active: {
      bordercolor: '#5D5D5D',
      bgcolor: '#888888',
      svgColorFilter: 'invert(100%) sepia(100%) saturate(0%) hue-rotate(288deg) brightness(102%) contrast(102%)'
    }
  },
  unknown: {
    default: {
      bgcolor: '#D1D1D1',
      bordercolor: 'white',
      svgColorFilter: 'invert(39%) sepia(3%) saturate(0%) hue-rotate(137deg) brightness(88%) contrast(85%);'
    },
    hover: {
      bgcolor: '#E7E7E7',
      bordercolor: '#B0B0B0'
    },
    active: {
      bordercolor: '#5D5D5D',
      bgcolor: '#888888',
      svgColorFilter: 'invert(100%) sepia(100%) saturate(0%) hue-rotate(288deg) brightness(102%) contrast(102%)'
    }
  },
  other: {
    default: {
      bgcolor: '#D1D1D1',
      bordercolor: 'white',
      svgColorFilter: 'invert(39%) sepia(3%) saturate(0%) hue-rotate(137deg) brightness(88%) contrast(85%);'
    },
    hover: {
      bgcolor: '#E7E7E7',
      bordercolor: '#B0B0B0'
    },
    active: {
      bordercolor: '#5D5D5D',
      bgcolor: '#888888',
      svgColorFilter: 'invert(100%) sepia(100%) saturate(0%) hue-rotate(288deg) brightness(102%) contrast(102%)'
    }
  }
}

export const AVAILABLES_LEVEL = [
  { value: 'down', color: '#DC2626', bgcolor: '#FEE2E2', svgColorFilter: 'invert(23%) sepia(84%) saturate(2581%) hue-rotate(348deg) brightness(90%) contrast(90%)' },
  { value: 'degraded', color: '#D97706', bgcolor: '#FEF3C7', svgColorFilter: 'invert(68%) sepia(86%) saturate(3010%) hue-rotate(1deg) brightness(106%) contrast(92%)' },
  { value: 'up', color: '#587F31', bgcolor: '#E6F0D7', svgColorFilter: 'invert(29%) sepia(54%) saturate(448%) hue-rotate(49deg) brightness(101%) contrast(91%)' },
  { value: 'installed', color: '#587F31', bgcolor: '#E6F0D7', svgColorFilter: 'invert(29%) sepia(54%) saturate(448%) hue-rotate(49deg) brightness(101%) contrast(91%)' },
  { value: 'event', color: '#D97706', bgcolor: '#FEF3C7', svgColorFilter: 'invert(63%) sepia(55%) saturate(591%) hue-rotate(7deg) brightness(96%) contrast(94%)' },
  { value: 'planned', color: '#1976D2', bgcolor: '#E3F2FD', svgColorFilter: 'invert(33%) sepia(56%) saturate(1367%) hue-rotate(178deg) brightness(92%) contrast(87%)' },
  { value: 'installing', color: '#1976D2', bgcolor: '#E3F2FD', svgColorFilter: 'invert(33%) sepia(56%) saturate(1367%) hue-rotate(178deg) brightness(92%) contrast(87%)' },
  { value: 'muted', color: '#1976D2', bgcolor: '#E3F2FD', svgColorFilter: 'invert(33%) sepia(56%) saturate(1367%) hue-rotate(178deg) brightness(92%) contrast(87%)' },
  { value: 'hibernation', color: '#5D5D5D', bgcolor: '#E7E7E7', svgColorFilter: 'invert(39%) sepia(3%) saturate(0%) hue-rotate(137deg) brightness(88%) contrast(85%)'},
  { value: 'hibernation_up', color: '#5D5D5D', bgcolor: '#E7E7E7', svgColorFilter: 'invert(39%) sepia(3%) saturate(0%) hue-rotate(137deg) brightness(88%) contrast(85%)'},
  { value: 'hibernation_down', color: '#DC2626', bgcolor: '#FEE2E2', svgColorFilter: 'invert(23%) sepia(84%) saturate(2581%) hue-rotate(348deg) brightness(90%) contrast(90%)'},
  { value: 'works', color: '#D97706', bgcolor: '#FEF3C7', svgColorFilter: 'invert(66%) sepia(22%) saturate(2755%) hue-rotate(358deg) brightness(99%) contrast(93%)' },
  { value: 'works_up', color: '#D97706', bgcolor: '#FEF3C7', svgColorFilter: 'invert(66%) sepia(22%) saturate(2755%) hue-rotate(358deg) brightness(99%) contrast(93%)' },
  { value: 'works_down', color: '#D97706', bgcolor: '#FEF3C7', svgColorFilter: 'invert(66%) sepia(22%) saturate(2755%) hue-rotate(358deg) brightness(99%) contrast(93%)' },
  { value: 'spare', color: '#8961BD', bgcolor: '#F4ECFE', svgColorFilter: 'invert(47%) sepia(17%) saturate(1830%) hue-rotate(224deg) brightness(87%) contrast(79%)' },
  { value: 'unknown', color: '#5D5D5D', bgcolor: '#E7E7E7', svgColorFilter: 'invert(39%) sepia(3%) saturate(0%) hue-rotate(137deg) brightness(88%) contrast(85%)'},
]

const getEquipmentSiteId = (equipment) => {
  return equipment?.site?.sf_id || equipment?.site?.id || equipment?.site_id || null
}

const isApEquipment = (equipment) => {
  return equipment?.type === 'ap' || equipment?.__typename === 'AP'
}

const isEslEquipment = (equipment) => {
  return equipment?.type === 'esl' || equipment?.__typename === 'ESL'
}

const normalizeEslFallbackLevel = (level) => {
  if (!level) return 'planned'
  return level === 'up' ? 'installed' : level
}

export const resolveEslAvailableLevel = ({ eslDevice, parentDevice = null, allEquipments = [] }) => {
  if (!eslDevice) return 'planned'

  const parentUuid = parentDevice?.uuid || eslDevice.parent || eslDevice.parent_uuid
  if (parentUuid) {
    const parentMonitoring = allEquipments.find(eq => eq.uuid === parentUuid)
    if (parentMonitoring) {
      return parentMonitoring.available_level === 'up' ? 'installed' : 'down'
    }
  }

  const eslSiteId = getEquipmentSiteId(eslDevice)
  const hasSiteApInProduction = allEquipments.some(eq => {
    if (!isApEquipment(eq)) return false
    if (eslSiteId && getEquipmentSiteId(eq) !== eslSiteId) return false
    return ['up', 'down'].includes(eq.available_level)
  })

  if (hasSiteApInProduction) {
    return 'installed'
  }

  return normalizeEslFallbackLevel(eslDevice.available_level || eslDevice.status || 'planned')
}

export const applyEslStatusResolution = ({ equipments = [], allEquipments = [] }) => {
  return equipments.map((equipment) => {
    if (!isEslEquipment(equipment)) return equipment
    return {
      ...equipment,
      available_level: resolveEslAvailableLevel({ eslDevice: equipment, allEquipments })
    }
  })
}

export const availableToColor = (available_level) => {
  const level = AVAILABLES_LEVEL.find(({ value }) => value === available_level)
  return level ? level.color : '#5D5D5D'
}

export const availableToBgColor = (available_level) => {
  const level = AVAILABLES_LEVEL.find(({ value }) => value === available_level)
  return level ? level.bgcolor : '#E7E7E7'
}

export const availableToSvgColorFilter = (available_level) => {
  const level = AVAILABLES_LEVEL.find(({ value }) => value === available_level)
  return level ? level.svgColorFilter : null
}

export const availableToTranslationKey = (available_level, complement='') => {
  return `supervision.status_availability.${available_level}${complement}`
}

export const availableTooltipToTranslationKey = (available_level) => {
  return `supervision.status_availability.tooltips.${available_level}`
}

export const getDeviceStatus = (device) => {
  if (!device) return { color: '#5D5D5D', bgcolor: '#E7E7E7', level: 'unknown' }
  
  let level = device.available_level || device.status || 'down'
  
  if (['hibernation', 'works'].includes(level)) {
    level = `${level}_${device.is_reachable ? 'up' : 'down'}`
  }
    
  return {
    color: availableToColor(level),
    bgcolor: availableToBgColor(level),
    level: level
  }
}

export const isRackType = (type) => {
  return ['rack', 'mer', 'ser'].includes(type)
}

export const normalizeRackAvailableLevel = (level) => {
  return ['installing', 'planned', 'muted'].includes(level) ? 'installed' : level
}

export const modelTypeToMarkerProps = ({ type, available_level }) => {
  const colors = SVG_COLORS[available_level] || SVG_COLORS['other']
  
  switch (type) {
    case 'ap':
      return { icon: '/icons/ap.svg', circle: true, colors }
    case 'switch':
      return { icon: '/icons/ethernet.svg', circle: false, colors }
    case 'esl':
      return { icon: '/icons/rectangle-barcode.svg', circle: false, colors }
    case 'tv':
      return { icon: '/icons/tv.svg', circle: false, colors }
    case 'chromecast':
      return { icon: '/icons/chromecast.svg', circle: false, colors }
    case 'firewall':
      return { icon: '/icons/firewall.svg', circle: false, colors }
    case 'wibox':
    case 'wifirst-server':
      return { icon: '/icons/router.svg', circle: false, colors }
    case 'cctv_camera':
      return { icon: '/icons/cctv.svg', circle: false, colors }
    case 'cctv_server':
      return { icon: '/icons/cctv_server.svg', circle: false, colors }
    case 'power-inverter':
      return { icon: '/icons/meter-bolt.svg', circle: false, colors }
    case 'rack':
    case 'mer':
    case 'ser':
      return { icon: null, circle: false, colors }
    default:
      return { icon: null }
  }
}

export const getDeviceColors = (device) => {
  if (!device) return SVG_COLORS['other']
  
  const deviceStatus = getDeviceStatus(device)
  let level = deviceStatus.level
  
  const availableLevel = device.available_level || device.status
  if (availableLevel && ['hibernation', 'works'].includes(availableLevel) && device.is_reachable !== undefined) {
    level = `${availableLevel}_${device.is_reachable ? 'up' : 'down'}`
  }
  
  return SVG_COLORS[level] || SVG_COLORS['other']
}

export const addSelectedProps = (device, activeEquipment) => {
  if (!activeEquipment || Object.keys(activeEquipment).length === 0) {
    return { selected: false }
  }
  switch (activeEquipment.type) {
    case 'ap':
    case 'switch':
    case 'esl':
    case 'wifirst-server':
    case 'wibox':
    case 'tv':
    case 'chromecast':
    case 'power-inverter':
      return { selected: device.uuid === activeEquipment.id }
    case 'ssid':
      return {
        selected: device.ssid_names
          ? device.ssid_names.includes(activeEquipment.label)
          : false,
      }
    default:
      return { selected: false }
  }
}

export const deserializeDevice = ({ device, activeEquipment }) => {
  if (!device) {
    return []
  }
  
  const isRack = isRackType(device.model?.type)
  
  if ((device.children && device.children.length > 0) || isRack) {
    return {
      ...device,
      x: device.position.x,
      y: device.position.y,
      type: device.model.type,
      id: device.uuid,
      uuid: device.uuid,
      label: device.label,
      color: availableToColor(device.available_level),
      selected: addSelectedProps(device, activeEquipment).selected
    }
  }

  const devices = {
    ...device,
    x: device.position.x,
    y: device.position.y,
    type: device.model.type,
    markers: [
      {
        id: device.uuid,
        name: device.label,
        is_reachable: device.is_reachable,
        nb_active_users: device.connected_stations,
        type: device.model.type,
        superscript: device.connected_stations,
        ...modelTypeToMarkerProps({
          type: device.model.type,
          available_level: device.available_level,
        }),
        ...addSelectedProps(device, activeEquipment),
        device
      },
    ],
  }
  
  if (device.child) {
    const { child } = device
    devices.markers.push({
      id: child.uuid,
      name: child.label,
      is_reachable: child.is_reachable,
      nb_active_users: child.connected_stations,
      ...modelTypeToMarkerProps({
        type: 'esl',
        available_level: child.available_level,
      }),
      ...addSelectedProps(child, activeEquipment)
    })
  }
  
  devices.markers = devices.markers.filter((item) => item.icon)
  return devices
}

export const normalizeString = (str) => {
  if (!str) return ''
  return str
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
}

export const formatBatteryTimeRemaining = (minutes) => {
  if (!minutes) return '-'
  if (minutes === 999) return '16h +'
  
  const hours = Math.floor(minutes / 60)
  const mins = minutes % 60
  
  const parts = []
  if (hours > 0) parts.push(`${hours}h`)
  if (mins > 0) parts.push(`${mins}min`)
  
  return parts.length > 0 ? parts.join(' ') : '-'
}
